import React, { useContext, useState } from "react";
import styles from "./HeaderIntroText.module.scss";

const HeaderIntroText = () => {
  return (
    <>
      <div
        className={`${styles.headerText} section`}
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/introBg.svg)` }}
      >
        <p>
          Your game might be over, but the fun doesn't have to stop <br /> there. Relive your best throws, victorious
          celebrations and group photos below!
        </p>
      </div>
    </>
  );
};

export default HeaderIntroText;
